
import { Component, Prop, Vue } from "vue-property-decorator";
import CopyToClipboard from "@/components/device-setup/clipboard/CopyToClipboard.vue";

@Component({
  components: {
    CopyToClipboard
  }
})

export default class TruncatedCopyableList extends Vue {
  @Prop({ required: true, type: Array }) listItems!: string[] | null;
  @Prop({ required: true }) rowIndex!: string | number;

  	private formatLatLng(val: any): string {
		return typeof val === "string" ? val.trim() : "";
	}
}
